import type {
	HelpArticleContent,
	HelpArticleRelated,
} from '@framework/ui-lib/help/jepto-help-article/jepto-help-article.component';

const HELP_AI_CREDITS = 'https://www.jepto.com/help/ai-credits';
const HELP_AI_MODELS = 'https://www.jepto.com/help/ai-models';
const AI_VISIBILITY_ROUTE = '/ai-visibility';
const DATA_CHAT_ROUTE = '/data-chat';

export const AI_VISIBILITY_HELP_IMAGE =	'assets/images/ai-visibility-help.png';
export const DATA_CHAT_HELP_IMAGE = 'assets/images/data-chat-help.png';

function appLink(href: string, label: string): string {
	return `<a href="${href}">${label}</a>`;
}

export const AI_CREDITS_USAGE_HELP_TITLE = 'What can I do with AI credits?';
export const AI_CREDITS_USAGE_HELP_DRAWER_ID = 'ai-credits-usage-help';

export function buildAiCreditsUsageHelpContent(): HelpArticleContent[] {
	return [
		{
			heading: 'AI Visibility',
			media: [
				{
					type: 'image',
					url: AI_VISIBILITY_HELP_IMAGE,
					alt: 'AI Visibility report showing named in answers, cited as a source, and share of voice',
					caption: '',
				},
			],
			body: `<p>Use credits to track how AI engines like ChatGPT, Claude and Google AI Mode mention your brand. Each tracked prompt consumes credits. ${appLink(AI_VISIBILITY_ROUTE, 'Start tracking with AI Visibility')}.</p>`,
		},
		{
			heading: 'Data Chat',
			media: [
				{
					type: 'image',
					url: DATA_CHAT_HELP_IMAGE,
					alt: 'Data Chat conversation showing AI model response and credit consumption',
					caption: '',
				},
			],
			body: `<p>For everyday tasks the default Jepto AI model doesn't consume a lot of credits. So with additional credits you can use larger models for more complex tasks or analysis. ${appLink(DATA_CHAT_ROUTE, 'Start using Data Chat')}.</p>`
		}
	];
}

export function buildAiCreditsUsageRelatedArticles(): HelpArticleRelated[] {
	return [
		{ title: 'AI Credits', url: HELP_AI_CREDITS },
		{ title: 'AI Models', url: HELP_AI_MODELS }
	];
}
